import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Auth, recordActions } from '../../config/configuration/react';
import { t } from '../../components/common/Translate';

export const usePricing = () => {
  const dispatch = useDispatch();
  const roleId = Auth.roleId();
  const { recordId } = useParams();
  const [locked, setLocked] = useState(null);
  const [user, setUser] = useState(null);
  let interval = null;
  const history = useHistory();

  async function lockPricing() {
    const res = await dispatch(recordActions.lockPricing(recordId));
    setLocked(res?.locked);
    setUser(res?.user);
  }

  const onBackButton = () => history.goBack();

  useEffect(() => {
    lockPricing();
    interval = setTimeout(function pushHistory() {
      onBackButton();
    }, 300000);

    return () => {
      clearTimeout(interval);
    };
  }, []);

  const activeTab = useSelector((state) => state.reduxRecords?.currentTab);

  const tabs = [
    {
      active: activeTab === 'pricing_title',
      name: t('pricing_title'),
      onClick: roleId === 1 ? undefined : () => dispatch(recordActions.changeCurrentTab('pricing_title')),
      disabled: roleId === 1,
    },
    {
      active: activeTab === 'coverageRequest',
      name: t('coverageRequest'),
      onClick: () => dispatch(recordActions.changeCurrentTab('coverageRequest')),
    },
  ];

  return { tabs, activeTab, recordId, locked, user, onBackButton };
};
